var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar-container"},[_c('wrap-container',{staticClass:"w100"},[_c('div',{staticClass:"inner-container"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/img/logo.svg"),"alt":"BBVA"}})]),_c('div',{staticClass:"modulo"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.config.modulo)}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }